import { STATUS, ADD_DECISION_ACTION } from "../constant";

const initState = {
  isApiLoading: null
};

export default (state = initState, action) => {
  switch (action.type) {
    case ADD_DECISION_ACTION.ADD_DECISION_START:
      return { ...state, isApiLoading: STATUS.LOADING };

    case ADD_DECISION_ACTION.ADD_DECISION_FAILURE:
      return { ...state, isApiLoading: STATUS.ERROR };

    case ADD_DECISION_ACTION.ADD_DECISION_SUCCESS:
      return {
        ...state,
        isApiLoading: STATUS.SUCCESS
      };

    default:
      return state;
  }
};
